






import { Component, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'

@Component
export default class AnimateFade extends Vue {
    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(element, {
            opacity: 0,
        })

        gsap.to(element, {
            duration: .2,
            opacity: 1,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(element, {
            duration: .2,
            opacity: 0,
            onComplete,
        })
    }
}
